import pwaConfig from "@/client/applications/saffronfiles/pwaConfig.js";

export default {
  waitForServerConfig: true,
  waitForServerLanguage: true,
  themeColor: pwaConfig.themeColor,
};
